export default __webpack_public_path__ + "assets/models/b3ef966d5fd7e4ff832857ee77164721.gltf";